import React, {FC, useMemo} from 'react';
import styled from 'styled-components';

import {StyledStretchGridItem} from '../../../../../../src/components/common/grid';
import {ContactsManagerPanelId} from '../../../../../../src/store/panels/panelStateBase';
import {buildInteractionIdProps} from '../../../../../shared/helpers/src/interaction/interactionHelpers';
import {ContactsManagerContext} from './contactsManagerContext';
import {ContactsManagerSidePanelContainer} from './contactsManagerSidePanelContainer';
import {ContactsManagerTrackEventHandler} from './helpers/trackingHelpers';
import {ContactsManagerNavigationContainer} from './navigation/contactsManagerNavigationContainer';
import {PageRoutingContainer} from './pages/pageRoutingContainer';

/*
 * Props.
 */

interface ContactsManagerProps {
  panelId: ContactsManagerPanelId;
  onTrackHandler: ContactsManagerTrackEventHandler;
}

/*
 * Style.
 */

const StyledContactsManagerContentDiv = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

const StyledContactsManagerWithNavigationDiv = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto auto 1fr;
  height: 100%;
  position: relative;
`;

/*
 * Component.
 */

export const ContactsManager: FC<ContactsManagerProps> = (props) => {
  const {panelId, onTrackHandler} = props;
  const context = useMemo(() => ({panelId, onTrackHandler}), [panelId, onTrackHandler]);

  const content = (
    <ContactsManagerContext.Provider value={context}>
      <StyledContactsManagerContentDiv {...buildInteractionIdProps('contacts-manager')}>
        <PageRoutingContainer panelId={panelId} />
      </StyledContactsManagerContentDiv>
      <ContactsManagerSidePanelContainer panelId={panelId} />
    </ContactsManagerContext.Provider>
  );

  return (
    <StyledContactsManagerWithNavigationDiv>
      <ContactsManagerNavigationContainer />
      <StyledStretchGridItem column={3}>{content}</StyledStretchGridItem>
    </StyledContactsManagerWithNavigationDiv>
  );
};
